import { ActionSuggestion } from '../model'
import { useCurrentUserIntegrations } from '../../../views/Integration/useCurrentUserIntegrations'
import { useAppSelector } from '../../../store/hooks'
import { useFilterSuggestions } from './useFilterSuggestions'
import { selectRoomSession } from '../../../store/meetingSummary/roomSession'

export const useSaveTaskSuggestions = (): ActionSuggestion[] => {
  const roomSession = useAppSelector(selectRoomSession)
  const { taskExportSupportedIntegrations } = useCurrentUserIntegrations()

  const suggestions = roomSession
    ? taskExportSupportedIntegrations.map(
        (integration): ActionSuggestion => ({
          actionType: 'createTask',
          serviceId: integration.serviceId,
          roomSession: roomSession,
          externalIntegration: integration,
        }),
      )
    : []

  return useFilterSuggestions(suggestions, 'createTask')
}
